import React from "react";

interface PassEmpty {
  from?: string;
  onClick?: () => void;
}

const PassEmpty = ({ from, onClick }: PassEmpty) => {
  return (
    <div className="pass-wrapper empty">
      <span className="title">이용권이 없어요.</span>
      <span className="desc">회원님께 이용권을 추천해주세요!</span>
      {from === "schedule" && (
        <div className="open-member-detail" onClick={onClick}>
          회원 상세보기
        </div>
      )}
    </div>
  );
};

export default PassEmpty;
